<template>
  <div class="contents_wrap">
    <div class="small_title_wrap">
      <h2>발송 정보</h2> <!--해외 특송-->
    </div>
    <ul class="filter_list">
      <li>
        <dd>
          <label>우든 포장 추가</label>
          <ul class="w50">
            <li>
              {{ sendInfo.woodenYn === 'Y' ? '추가' : '미사용' }}
            </li>
          </ul>
        </dd>
        <dd>
          <label>보관 위치</label>
          <ul class="w50">
            <li>
              {{ !!sendInfo.lockerNm ? sendInfo.lockerNm : '-' }}
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label>수량</label>
          <ul class="w50">
            <li>
              {{ sendInfo.qty }}
            </li>
          </ul>
        </dd>
        <dd>
          <label>무인 보관함 번호</label>
          <ul class="w50">
            <li>
              {{ !!sendInfo.lockerCellId ? sendInfo.lockerCellId : '-' }}
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label>비고</label>
          <ul class="w50">
            <li>
              {{ !!sendInfo.contents ? sendInfo.contents : '-' }}
            </li>
          </ul>
        </dd>
        <dd>
        </dd>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SendDetailDeli",
  props: {
    sendInfo : {
      type : Object,
      required : false,
      default : function (){
        return {}
      }
    },
  },
}
</script>

<style scoped>

</style>
